__webpack_require__.p = "/Dictionary-of-GE-s-People-and-Places/";